<template>
  <div class="login-page container-fluid min-vh-100">
    <div class="row min-vh-100 align-items-center">

      <!-- COLUNA ESQUERDA -->
      <div class="col-12 col-lg-8 d-flex align-items-center justify-content-center">
        <div class="login-card w-100 mx-auto">

          <router-link to="/" class="voltar mb-4 d-inline-flex align-items-center">
            ← Voltar
          </router-link>

          <!-- LOGO -->
          <div class="mb-4 d-flex align-items-center gap-2">
            <img src="../img/logotipo-icon.png" height="38" />
          </div>

          <!-- TÍTULO -->
          <div class="page-header mb-4">
            <p class="page-header-eyebrow">LOGIN</p>
            <h1 class="page-title mb-1">Acessar minha conta</h1>
          </div>
          <p class="page-subtitle mb-4">
            Ainda não tem uma conta?
            <router-link to="/create-account">Criar conta</router-link>
          </p>

          <!-- FORM -->
            <form @submit.prevent="login()">

            <!-- E-MAIL -->
            <label class="form-label">E-mail</label>
            <div class="campo-senha mb-3">
            <img
                src="../img/email-icon.png"
                class="icone cadeado"
                alt="E-mail"
            />

            <input
                type="email"
                class="form-control input-senha"
                v-model="email"
                placeholder="Digite seu email"
                required
            />
            </div>

            <!-- SENHA -->
            <label class="form-label">Senha</label>
            <div class="campo-senha mb-3">

            <img
                src="../img/block-blue-icon.png"
                class="icone cadeado"
                alt="Senha"
            />

            <input
                :type="mostrarNovaSenha ? 'text' : 'password'"
                class="form-control input-senha"
                v-model="senha"
                placeholder="Digite sua senha"
                required
            />

            <img
                src="../img/eye-icon.png"
                class="icone olho"
                alt="Mostrar senha"
                @click="mostrarNovaSenha = !mostrarNovaSenha"
            />
            </div>

            <div class="d-flex justify-content-between align-items-center mb-4">
              <div class="form-check">
                <input
                class="form-check-input"
                type="checkbox"
                id="lembrar"
                v-model="lembrarSenha"
                />
                <label class="form-check-label" for="lembrar">
                  Lembrar meu e-mail
                </label>
              </div>

              <router-link to="/recover-password">
                Esqueci minha senha
              </router-link>
            </div>

            <button type="submit" class="btn btn-primary botao-azul w-100">
                Acessar minha conta
            </button>

            <div class="ou-separador"><span>ou</span></div>

            <button type="button" class="btn btn-google w-100" @click="loginComGoogle">
              <span class="google-icon">G</span>
              Continuar com Google
            </button>

            </form>

        </div>
      </div>

      <!-- COLUNA DIREITA -->
        <div class="col-lg-4 d-none d-lg-flex login-banner p-0">
        <img
          src="../img/banner.png"
            class="login-banner-img"
            alt="Banner"
        />
        </div>

    </div>

    <!-- MODAIS -->
    <AlertModal
      :visible="alertModal.visible"
      :title="alertModal.title"
      :message="alertModal.message"
      :type="alertModal.type"
      @close="fecharAlert"
    />

  </div>
</template>

<script>

import AlertModal from '@/componentesTelas/AlertModal.vue';
import { getDeviceId, setSessionId, setUsuario } from '@/utils/authStorage';

export default {
  name: "Login",

  data() {
    return {
      email: "",
      senha: "",
      lembrarSenha: false,
      mostrarNovaSenha: false,

      // Modal genérico
      alertModal: {
        visible: false,
        title: '',
        message: '',
        type: 'info'
      },
    };
  },

  components: {
    AlertModal
  },

  mounted() {
    this.processarCallbackGoogle();
    const emailSalvo = localStorage.getItem("email_lembrado");

    if (emailSalvo) {
        this.email = emailSalvo;
        this.lembrarSenha = true;
    }
  },

  methods: {

    loginComGoogle() {
      const deviceId = encodeURIComponent(getDeviceId());
      window.location.href = `${process.env.VUE_APP_BACKEND_URL}/auth/google?deviceId=${deviceId}`;
    },

    processarCallbackGoogle() {
      const params = new URLSearchParams(window.location.search);
      const resultado = params.get('google');

      if (resultado === 'success') {
        try {
          const payload = params.get('data').replace(/-/g, '+').replace(/_/g, '/');
          const usuario = JSON.parse(atob(payload));
          setSessionId(usuario.sessionId);
          setUsuario(usuario);
          this.$router.replace('/app');
        } catch (error) {
          this.abrirAlert('Sistema', 'Não foi possível concluir o login com Google.', 'error');
        }
      } else if (resultado === 'error') {
        this.abrirAlert('Sistema', 'Não foi possível entrar com sua conta Google.', 'error');
        this.$router.replace('/login');
      } else if (resultado === 'blocked') {
        this.abrirAlert('Acesso bloqueado', 'Este usuário já está conectado em outro computador. Encerre a sessão anterior para continuar ou, se já encerrou, aguarde alguns minutos para que a sessão expire e tente novamente.', 'error');
        this.$router.replace('/login');
      }
    },

    abrirAlert(title, message, type = 'info') {
      this.alertModal = {
        visible: true,
        title,
        message,
        type
      };
    },

    fecharAlert() {
      this.alertModal.visible = false;
    },

    async login() {
      // validação básica
      if (this.senha.length < 8) {
        this.abrirAlert("Sistema", "A senha deve ter no mínimo 8 caracteres.", "error");
        return;
      }

      try {
        const response = await fetch(
          `${process.env.VUE_APP_BACKEND_URL}/login`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              email: this.email,
              senha: this.senha,
              deviceId: getDeviceId()
            })
          }
        );

        const data = await response.json();

        if (!response.ok) {
          this.abrirAlert("Sistema", data.message || data.erro, "error");
          return;
        }

        // LEMBRAR EMAIL
        if (this.lembrarSenha) {
          localStorage.setItem("email_lembrado", this.email);
        } else {
          localStorage.removeItem("email_lembrado");
        }

        // LOGIN OK
        setUsuario({
          nome: data.nome,
          email: data.email,
          tipo: data.tipo
        });
        setSessionId(data.sessionId);

        this.$router.push("/");

      } catch (error) {
        console.error("Erro no login:", error);
        this.abrirAlert("Sistema", error.message, "error");
      }
    }
  }
};
</script>


<style>

input[type="checkbox"] {
  min-width: 5px;
}

.login-page {
  background: #ffffff;
}

.login-page a {
  color: #0056ff;
  font-weight: 700;
}

.login-card {
  max-width: 420px;
  padding: 32px;
}

.login-card .page-header {
  margin-bottom: 8px;
}

.voltar {
  color: #0056ff;
  text-decoration: none;
  font-weight: 500;
}

.voltar:hover {
  text-decoration: underline;
}

.btn-login {
  background: #0056ff;
  border-radius: 8px;
  font-weight: 700;
  padding: 12px;
}

.btn-login:hover {
  background: #000;
}

.ou-separador {
  align-items: center;
  color: #6c757d;
  display: flex;
  gap: 12px;
  margin: 18px 0;
}

.ou-separador::before,
.ou-separador::after {
  background: #dee2e6;
  content: "";
  flex: 1;
  height: 1px;
}

.btn-google {
  align-items: center;
  background: #fff;
  border: 1px solid #ced4da;
  color: #212529;
  display: flex;
  font-weight: 600;
  gap: 10px;
  justify-content: center;
  padding: 12px;
}

.btn-google:hover {
  background: #f8f9fa;
  border-color: #adb5bd;
}

.google-icon {
  color: #4285f4;
  font-size: 18px;
  font-weight: 700;
}

/* BANNER DIREITO */
.login-banner {
  height: 100vh;
  justify-content: flex-end;
}

.login-banner-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

@media (min-width: 768px) and (max-width: 991.98px) {
  .login-card {
    max-width: 420px !important;
  }
}

@media (max-width: 575.98px) {
  .login-card {
    padding: 24px 20px;
  }
}


</style>